import { ILobbyDetailComponent } from "../view/screens/lobby/ILobbyDetailComponent";

export class AbstractLobbyDetailVO {
    public lobbyDetailType: number = 0;

    public lobbyDetailViewInstance: ILobbyDetailComponent;

    /** Indicates wether the detail should be shown, or just updated **/
    public update: boolean = false;

    public toString(): string {
        return "lobbyDetailType: " + this.lobbyDetailType + ", update: " + this.update;
    }
}
